import { render, staticRenderFns } from "./SeaFreight.vue?vue&type=template&id=cbb151e2&scoped=true&"
import script from "./SeaFreight.vue?vue&type=script&lang=js&"
export * from "./SeaFreight.vue?vue&type=script&lang=js&"
import style0 from "./SeaFreight.vue?vue&type=style&index=0&id=cbb151e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb151e2",
  null
  
)

export default component.exports